// Browsers with site data blocked throw on any localStorage/sessionStorage access, and Android WebViews
// without DOM storage return null, so the first read crashes the page. Fall back to in-memory storage.
export function installStorageGuard() {
  if (typeof window === 'undefined') return;

  (['localStorage', 'sessionStorage'] as const).forEach((name) => {
    try {
      window[name].getItem('');
    } catch {
      const items = new Map<string, string>();
      Object.defineProperty(window, name, {
        value: {
          get length() {
            return items.size;
          },
          key: (index: number) => Array.from(items.keys())[index] ?? null,
          getItem: (key: string) => items.get(key) ?? null,
          setItem: (key: string, value: string) => {
            items.set(key, String(value));
          },
          removeItem: (key: string) => {
            items.delete(key);
          },
          clear: () => {
            items.clear();
          },
        },
      });
    }
  });
}
